// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"25":"ui/main/css/main","136":"ui/main/css/cart","286":"ui/main/css/heals_homepage","320":"ui/main/css/_product_page","587":"ui/main/css/product"}[chunkId] + ".css";
};